import React from 'react'

export const CameraIcon = props => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29Z"
        fill="#2E3860"
        stroke="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0836 11.0309H11.3721V10.5678H10.0836V11.0309ZM12.8401 15.3636C12.8401 16.5332 13.8073 17.481 15 17.481C16.1931 17.481 17.1599 16.5332 17.1599 15.3636C17.1599 14.1944 16.1931 13.2462 15 13.2462C13.8073 13.2462 12.8401 14.1944 12.8401 15.3636ZM18.9213 12.6437C18.9213 12.8508 18.7499 13.0188 18.5386 13.0188H18.5309C18.3195 13.0188 18.1482 12.8508 18.1482 12.6437V12.6361C18.1482 12.4289 18.3195 12.2609 18.5309 12.2609H18.5386C18.7499 12.2609 18.9213 12.4289 18.9213 12.6361V12.6437ZM12.2401 15.3623C12.2401 13.8706 13.4783 12.6567 15 12.6567C16.5217 12.6567 17.7599 13.8706 17.7599 15.3623C17.7599 16.8544 16.5217 18.0678 15 18.0678C13.4783 18.0678 12.2401 16.8544 12.2401 15.3623ZM18.137 11.4117C17.9764 11.4117 17.8265 11.333 17.7376 11.202L17.0624 10.2097C16.9735 10.0787 16.8236 10 16.663 10H13.337C13.1764 10 13.0265 10.0787 12.9376 10.2097L12.2624 11.202C12.1735 11.333 12.0236 11.4117 11.863 11.4117H10.2885C9.57681 11.4117 9 11.9772 9 12.6748V17.7369C9 18.4346 9.57681 19 10.2885 19H19.7115C20.4232 19 21 18.4346 21 17.7369V12.6748C21 11.9772 20.4232 11.4117 19.7115 11.4117H18.137Z"
        fill="white"
      />
    </svg>
  )
}
